<template>
	<el-drawer :title="formData.id ? '编辑标签' : '新增标签'" :visible.sync="drawerShow" :wrapperClosable="false"
		:destroy-on-close="true" size="auto" @close="close">
		<div class="drawer-content" v-loading="dataLoading">
			<el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
				<el-row :gutter="20">
					<el-col :md="12">
						<el-form-item prop="parentId" label="标签所属层级:">
							<el-cascader ref="cascader" style="width:100%" v-model="formData.parentId"
								:options="cascade"
								:props="{ checkStrictly: true, emitPath:false, value: 'id', label: 'name', children: 'childList' }"
								clearable size="small" placeholder="对象/一级标签/二级标签" filterable>
							</el-cascader>
						</el-form-item>
					</el-col>
					<el-col :md="12">
						<el-form-item prop="name" label="名称:">
							<el-input v-model="formData.name" maxlength="40"></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12">
						<el-form-item prop="processType" label="加工类型:">
							<el-select v-model="formData.processType">
								<el-option :value="1" label="原始类"></el-option>
								<el-option :value="2" label="统计类"></el-option>
								<el-option :value="3" label="算法类"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<!-- <el-col :md="12">
                        <el-form-item prop="valueType" label="字段类型:">
                            <el-select v-model="formData.valueType">
                                <el-option :value="1" label="数值"></el-option>
                                <el-option :value="2" label="文本"></el-option>
                                <el-option :value="3" label="日期"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
					<el-col :md="12">
						<el-form-item prop="natureType" label="性质类型:">
							<el-select v-model="formData.natureType">
								<el-option :value="1" label="事实数据"></el-option>
								<el-option :value="2" label="业务逻辑"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="12">
						<el-form-item prop="updateCycle">
							<span slot="label"> 更新周期（天）：<small>填写0表示该标签暂无明确的更新周期</small></span>
							<el-input-number style="width:100%" v-model="formData.updateCycle" :min="0" :max="9999"
								:controls="false" :precision="0"></el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :md="12">
						<el-form-item prop="wideColumn" label="字段名:">
							<el-input v-model="formData.wideColumn" maxlength="60" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="12">
						<el-form-item prop="valueType" label="字段类型:">
							<el-select v-model="formData.valueType">
								<el-option :value="1" label="数值"></el-option>
								<el-option :value="2" label="文本"></el-option>
								<el-option :value="3" label="日期"></el-option>
								<el-option :value="4" label="JSON"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-form-item v-if="formData.valueType == 4 " class="MT10">
					<el-card class="optionsList">						
						<el-table border style="width: 100%" size="small" stripe :data="actTable">
							<el-table-column prop="order" label="序号"  type="index" width="80"></el-table-column>							
							<el-table-column prop="wideColumn" label="Key变量名">
								<template slot-scope="scope">
									<div class="ellipsis" :title="scope.row.wideColumn">
										<el-input v-model="scope.row.wideColumn" clearable maxlength="40" show-word-limit></el-input>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="Key中文" >							
								<template slot-scope="scope">
									<div class="ellipsis" :title="scope.row.name">
										<el-input v-model="scope.row.name" clearable  maxlength="40" show-word-limit></el-input>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="80">
								<template slot-scope="scope">
									<el-button type="danger" icon="el-icon-delete"  @click="del(scope.$index)" size="mini" plain></el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-card>
					<div class="xxIpt2">
						<el-button icon="el-icon-plus" size="mini" type="primary"
							@click="addOptions()">增加Key</el-button>
					</div>
				</el-form-item>
				<el-form-item prop="valueLogic" label="取值逻辑:">
					<el-input v-model="formData.valueLogic" type="textarea" maxlength="500" show-word-limit></el-input>
				</el-form-item>
				<el-form-item prop="remark" label="备注:">
					<el-input v-model="formData.remark" type="textarea" maxlength="100" show-word-limit></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
		</div>
	</el-drawer>
</template>

<script>
	const defaultData = {
		name: "",
		object: "",
		parentId: "",
		processType: "",
		remark: "",
		updateCycle: undefined,
		valueLogic: "",
		valueType: "",
		natureType: "",
		cascadeValue: "",
		wideColumn: ""

	}
	export default {
		props: {
			cascade: {
				type: Array,
				default: []
			}
		},
		data() {
			return {
				drawerShow: false,
				btnLoading: false,
				dataLoading: false,
				formData: {
					...defaultData
				},
				rules: {
					parentId: [{
						required: true,
						message: "请选择标签所属层级"
					}],
					name: [{
						required: true,
						message: "请填写名称"
					}],
					processType: [{
						required: true,
						message: "请选择加工类型"
					}],
					valueLogic: [{
						required: true,
						message: "请填写取值逻辑"
					}],
					valueType: [{
						required: true,
						message: "请选择取值类型"
					}],
					natureType: [{
						required: true,
						message: "请选择性质类型"
					}],
					updateCycle: [{
						required: true,
						message: "请填写更新周期"
					}],
					wideColumn: [{
						required: true,
						message: "请填写宽表字段名"
					}]
				},
				
				ParamsNum: 0,
				actTable:[]
			}
		},
		methods: {
			close() {
				this.$refs.formData.resetFields();
				this.formData = {
					...defaultData
				}
				this.actTable = []
				this.drawerShow = false;
			},
			show(id) {
				if (id) {
					this.formData.id = id;
					this.getData();
				}
				this.drawerShow = true;
			},
			getData() {
				this.dataLoading = true;
				this.$request({
						url: '/label/detail',
						params: {
							id: this.formData.id
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state && result) {
							this.formData = {
								...this.formData,
								...result
							}
							var array = []
							if (result.jsonValue) {
								result.jsonValue.forEach((tab, idx) => {
									array.push({
										order: idx,
										name: tab.name,
										wideColumn:tab.wideColumn
									})
								})
								this.actTable = array
							}
							
						} else {
							this.$message.error(msg || "操作失败,请重试");
						}
					})
					.catch(() => {
						self.$message.error("操作失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},
			addOptions() {
				var empty = false
				if ( this.actTable && this.actTable.length > 0 && this.formData.valueType == 4 ) {
					this.actTable.forEach((tab, idx) => {
						if (tab.wideColumn == '' || tab.name == '') {
							empty = true
						}
					})
				}
				if( empty ){
					return this.$message.error("Key变量名和Key中文不能为空！");
				}				
				this.ParamsNum++;				
				const newRow = { order: this.ParamsNum, wideColumn: '',  name: '', };	
				this.actTable.push(newRow);
			},
			del(index) {
				this.ParamsNum--
				this.actTable.splice(index,1)
			},
			submitForm() {
				if (this.formData.parentId != '') {
					var _nodes = this.$refs.cascader.getCheckedNodes();
					var _object = _nodes[0].pathNodes[0].value;
				} else {
					this.$message.error("请选择标签所属层级！");
				}				
				
				if( this.formData.valueType == 4 && this.actTable && this.actTable.length == 0 ){
					return this.$message.error("请先添加Key！");
				}	
				
				var optionList2 = [], empty = false;
				if ( this.actTable && this.actTable.length > 0 || this.formData.valueType == 4 ) {
					this.actTable.forEach((tab, idx) => {
						if (tab.wideColumn == '' || tab.name == '') {
							empty = true
						}
						if (tab.wideColumn != '' && tab.name != '') {
							let obj = {
								wideColumn: tab.wideColumn,
								name: tab.name
							}
							optionList2.push(obj)
						}
					})
				}
				if( empty ){
					return this.$message.error("Key变量名和Key中文不能为空！");
				}

				this.$refs["formData"].validate((valid) => {
					if (valid) {
						this.btnLoading = true;
						this.$request({
								url: '/label/edit',
								data: {
									...this.formData,
									object: _object,
									jsonValue: optionList2
								},
								method: "post",
							})
							.then((res) => {
								const {
									state,
									msg
								} = res.data;
								if (state == 1) {
									this.$emit('onUpdate');
									this.close();
								} else {
									this.$message.error(msg || "操作失败,请重试");
								}
							})
							.catch(() => {
								self.$message.error("操作失败,请重试");
							})
							.finally(() => {
								this.btnLoading = false;
							});
					} else {
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.xxIpt,
	.xxIpt2 {
		display: flex;
		align-items: center;
		width: 100%;

		span {
			padding-right: 15px;
			width: 70px;
			text-align: right;
		}

		.ipt {
			width: 85%;

		}
	}

	.xxIpt2 {
		margin-top: 20px;
	}

	.optionsList {

		.ipt {
			width: 100%;
			margin-bottom: 10px;
		}
	}

	::v-deep .el-card__header {
		padding: 4px 0 4px 20px;
	}

	// .optionsList{
	// 	display: flex;
	// 	align-items: center;
	// 	width: 100%;
	// 	.optionName{
	// 		margin-left: 90px;
	// 	}
	// 	.el-icon-remove-outline{
	// 		margin-left: 10px;
	// 	}
	// }
</style>